<template>
  <div>
    <v-dialog width="500" v-model="dialog">
      <v-card>
        <v-card-title>
          Filtrer et exporter
          <v-spacer/>
          <v-icon @click="dialog = false">mdi-close</v-icon>
        </v-card-title>
        <v-divider/>
        <v-card-text class="pa-8">

          <v-select outlined
                    prepend-inner-icon="mdi-filter-outline"
                    v-model="form.statuses"
                    dense
                    label="Statuses"
                    chips
                    multiple
                    small-chips
                    deletable-chips
                    :items="statuses"
                    item-value="value"
                    item-text="name"
          />

          <v-autocomplete multiple
                          v-model="form.campaigns"
                          prepend-inner-icon="mdi-filter-outline"
                          chips
                          deletable-chips
                          small-chips
                          item-text="name.fr"
                          item-value="id"
                          :items="campaigns"
                          outlined
                          dense
                          label="Campagnes"/>

          <v-btn block color="gifty" class="white--text" depressed
                 @click="exportData"
                 :loading="exportLoading">
            <v-icon left>mdi-export</v-icon>
            Exporter
          </v-btn>

        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {HTTP} from "@/http-common";

export default {
  props: ['campaigns'],
  data() {
    return {
      dialog: false,
      exportLoading: false,
      form: {
        statuses: [],
        campaigns: []
      },
      statuses: [
        {name: "En attente", value: "pending"},
        {name: "Validée temp.", value: "temp_validated"},
        {name: "Refusée temp.", value: "temp_refused"},
        {name: "Validée", value: "validated"},
        {name: "Refusée", value: "refused"},
        {name: "Reclamée", value: "reclaimed"},
      ]
    }
  },
  methods: {
    open() {
      this.dialog = true
    },
    exportData() {
      this.exportLoading = true
      HTTP.post('/v1/opus/backoffice/export', this.form, {responseType: 'blob'})
          .then((res) => {
            const url = window.URL.createObjectURL(new Blob([res.data]))
            const a = document.createElement('a')
            a.href = url
            a.download = 'opus.xlsx'
            document.body.appendChild(a)
            a.click()
            a.remove()
            window.URL.revokeObjectURL(url)
            this.dialog = false
            this.exportLoading = false
          })
          .catch((err) => {
            console.error('Erreur export:', err)
            this.exportLoading = false
          })
    }
  }
}
</script>

<style scoped>

</style>